import ModalEditTable from '../CRUDUtils/ModalEditTable';
import { Link } from 'react-router-dom';

export default function HardwareTypesPage() {
  const columns = [
    {
      title: 'Model',
      dataIndex: 'hardware_model',
      key: 'hardware_model',
      sorter: (a, b) => a.hardware_model.localeCompare(b.hardware_model)
    },
    {
      title: 'Meta',
      dataIndex: 'hardware_meta',
      key: 'hardware_meta',
      sorter: (a, b) => a.hardware_meta.localeCompare(b.hardware_meta)
    },
    {
      title: 'Make',
      dataIndex: 'hardware_make',
      key: 'hardware_make',
      sorter: (a, b) => a.hardware_make.localeCompare(b.hardware_make)
    },
  ];

  const formFields = [

    {
      name: 'hardware_type_id',
      label: 'Hardware Type ID',
      type: 'textarea',
      placeholder: 'Hardware Type ID',
      disabled: true,
    },
    {
      name: 'hardware_model',
      label: 'Model',
      type: 'textarea',
      placeholder: 'Model',
      rules: [{ required: true, message: 'Must Enter a Hardware Model!' }]
    },
    {
      name: 'hardware_make',
      label: 'Make',
      type: 'textarea',
      placeholder: 'Make',
      rules: [{ required: true, message: 'Must Enter a Hardware Make!' }]
    },
    {
      name: 'hardware_meta',
      label: 'Meta',
      type: 'textarea',
      placeholder: 'Meta',
      rules: [{ required: true, message: 'Must Enter a Hardware Meta!' }]
    },
  ];


  return (
    <div className='container-wrapper'>
      <ModalEditTable
        createEndpoint="create/hardwaretypes"
        readEndpoint="read/hardwaretypes"
        editEndpoint="update/hardwaretypes"
        deleteEndpoint="delete/hardwaretypes"
        columns={columns}
        formFields={formFields}
        title="Hardware Types"
      />
    </div>
  );
}